module.exports = __webpack_public_path__ + "img/logo_NU_cdr.2a620ae0.jpg";